<script setup>
import { useGlobalStore } from '@stores/global'

import ArticleCard from '@components/global/article-card.vue'
import Footer from '@components/global/footer.vue'
import Header from '@components/global/header.vue'

const global = useGlobalStore()
</script>
<template>
	<Header />
	<section class="container flex flex-col items-center">
		<span class="h9">page not found</span>
		<span class="font-extrabold text-[5rem] md:text-[10rem]">Error 404</span>
		<span class="font-medium text-sm leading-7 text-primaryLight">We couldn't find what you were looking for.</span>
	</section>
	<section class="container flex flex-col gap-6 lg:w-half">
		<span class="h9">suggested articles</span>
		<div class="flex flex-col gap-6">
			<ArticleCard v-for="item of global.news.slice(0, 3)" :item="item" />
		</div>
	</section>
	<Footer />
</template>
